/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationStatus } from './IntegrationStatus';
import {
    IntegrationStatusFromJSON,
    IntegrationStatusFromJSONTyped,
    IntegrationStatusToJSON,
    IntegrationStatusToJSONTyped,
} from './IntegrationStatus';

/**
 * 
 * @export
 * @interface ProjectStatus
 */
export interface ProjectStatus {
    /**
     * 
     * @type {Array<IntegrationStatus>}
     * @memberof ProjectStatus
     */
    integrationStatuses?: Array<IntegrationStatus>;
}

/**
 * Check if a given object implements the ProjectStatus interface.
 */
export function instanceOfProjectStatus(value: object): value is ProjectStatus {
    return true;
}

export function ProjectStatusFromJSON(json: any): ProjectStatus {
    return ProjectStatusFromJSONTyped(json, false);
}

export function ProjectStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationStatuses': json['integrationStatuses'] == null ? undefined : ((json['integrationStatuses'] as Array<any>).map(IntegrationStatusFromJSON)),
    };
}

export function ProjectStatusToJSON(json: any): ProjectStatus {
    return ProjectStatusToJSONTyped(json, false);
}

export function ProjectStatusToJSONTyped(value?: ProjectStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationStatuses': value['integrationStatuses'] == null ? undefined : ((value['integrationStatuses'] as Array<any>).map(IntegrationStatusToJSON)),
    };
}

